import { render, staticRenderFns } from "./Bo6OverlayPage.vue?vue&type=template&id=3d5e7a0e&"
import script from "./Bo6OverlayPage.vue?vue&type=script&lang=js&"
export * from "./Bo6OverlayPage.vue?vue&type=script&lang=js&"
import style0 from "./Bo6OverlayPage.vue?vue&type=style&index=0&class=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports